var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnreadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 5.81667V13.3333C18.3332 14.25 17.5832 15 16.6665 15H4.99984L1.6665 18.3333V3.33333C1.6665 2.41667 2.4165 1.66667 3.33317 1.66667H11.7498C11.6998 1.93333 11.6665 2.21667 11.6665 2.5C11.6665 2.78333 11.6998 3.06667 11.7498 3.33333H3.33317V13.3333H16.6665V6.58333C17.2832 6.45833 17.8498 6.18333 18.3332 5.81667ZM13.3332 2.5C13.3332 3.88333 14.4498 5 15.8332 5C17.2165 5 18.3332 3.88333 18.3332 2.5C18.3332 1.11667 17.2165 0 15.8332 0C14.4498 0 13.3332 1.11667 13.3332 2.5Z",
    fill: "#7F7F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadIcon);
export default __webpack_public_path__ + "static/media/Unread-icon.e2173cf825eafbf2c652334933931281.svg";
export { ForwardRef as ReactComponent };